import { render, staticRenderFns } from "./CustomerUserForm.vue?vue&type=template&id=642bb793&scoped=true&"
import script from "./CustomerUserForm.vue?vue&type=script&lang=js&"
export * from "./CustomerUserForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomerUserForm.vue?vue&type=style&index=0&id=642bb793&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642bb793",
  null
  
)

export default component.exports